import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex w-full flex-col gap-3" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = { class: "relative flex flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách dân cư trong tổ" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_DataTable, {
          loading: _ctx.isLoading,
          value: $setup.listPeople,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10, 25, 50],
          rowHover: true,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          filters: $setup.filters,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters) = $event)),
          globalFilterFields: ['fullName', 'phoneNumber'],
          currentPageReportTemplate: "Có tổng số {totalRecords} cư dân",
          resizableColumns: "",
          tableclass: "h-[60px]"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Button, {
                    type: "button",
                    icon: "pi pi-filter-slash",
                    label: "Xoá",
                    outlined: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearFilter())),
                    class: "w-[6em]"
                  }),
                  _createElementVNode("span", _hoisted_5, [
                    _cache[5] || (_cache[5] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                    _createVNode(_component_InputText, {
                      class: "!w-[500px] !pl-10 !pr-3",
                      modelValue: $setup.filters['global'].value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters['global'].value) = $event)),
                      placeholder: "Tìm theo tên hoặc số điện thoại"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-trash",
                  label: "Xoá đã chọn",
                  severity: "danger",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.deleteSelectedPeople())),
                  loading: $setup.deletingSelected,
                  disabled: $setup.selectedPeopleIds.length < 1,
                  class: "w-fit"
                }, null, 8, ["loading", "disabled"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "",
              class: "h-[60px]"
            }, {
              header: _withCtx(() => [
                _createVNode(_component_Checkbox, {
                  modelValue: $setup.isAllSelected,
                  binary: true,
                  "onUpdate:modelValue": $setup.toggleSelectAll
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_component_Checkbox, {
                  modelValue: $setup.isSelected(slotProps.data),
                  binary: true,
                  "onUpdate:modelValue": ($event: any) => ($setup.toggleSelect(slotProps.data))
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "fullName",
              header: "Họ và tên",
              sortable: "",
              class: "h-[60px]"
            }),
            _createVNode(_component_Column, {
              field: "phoneNumber",
              header: "Số điện thoại",
              class: "h-[60px]",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              header: "Thao tác",
              class: "h-[60px]"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  severity: "danger",
                  label: "Xoá",
                  icon: "pi pi-trash",
                  onClick: ($event: any) => ($setup.deletePerson(slotProps.data)),
                  loading: $setup.deletingId === $setup.getPersonId(slotProps.data),
                  class: "!min-h-[36px] px-3 py-1.5"
                }, null, 8, ["onClick", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value", "filters"])
      ]),
      _createVNode(_component_ConfirmDeleteModal, {
        modelValue: $setup.showConfirmModal,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.showConfirmModal) = $event)),
        title: $setup.confirmTitle,
        message: $setup.confirmMessage,
        "is-loading": $setup.isConfirming,
        onConfirm: $setup.confirmAction,
        onCancel: $setup.cancelAction
      }, null, 8, ["modelValue", "title", "message", "is-loading", "onConfirm", "onCancel"])
    ]),
    _: 1
  }))
}